import { DestroyRef, Injectable, NgZone } from '@angular/core';
import { EnvironmentService } from '../environment-service/environment.service';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { RudderStackService } from '@services/rudderstack/rudderstack.service';
import posthog from 'posthog-js';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { selectCloudflareMeta } from '@selectors/app.selector';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  constructor(
    private rudderStackService: RudderStackService,
    private growthBookService: GrowthBookService,
    public router: Router,
    private destroyRef: DestroyRef,
    private ngZone: NgZone,
    private store: Store
  ) {}

  public initPosthog() {
    const enabled =
      this.growthBookService.isFeatureEnabled('feat-002959-posthog-enabled') &&
      EnvironmentService.environment.posthog.enabled;

    if (!enabled) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      posthog.init(EnvironmentService.environment.posthog.apiKey, {
        api_host: EnvironmentService.environment.posthog.host,
        capture_pageview: false,
        capture_pageleave: true,
        debug: false,
        cross_subdomain_cookie: true,
        person_profiles: 'always',
        loaded: (posthogInstance) => {
          this.router.events
            .pipe(
              filter((event) => event instanceof NavigationEnd),
              takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
              posthogInstance.capture('$pageview');
            });
          posthogInstance.identify(this.rudderStackService.getAnonymousId());
        },
      });

      this.rudderStackService.onReady$.subscribe(() => {
        const userId = this.rudderStackService.getAnonymousId();
        if (userId && userId.length > 0) {
          posthog.identify(userId, { anonymousId: userId });
          console.log('anonymous_id', userId);
        }
      });

      this.store.select(selectCloudflareMeta).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((meta) => {
        if (meta) {
          posthog.capture('cf_meta', meta);
        }
      });
    });
  }
}
